import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { LanguageProvider } from './contexts/LanguageContext';

// Import components
import EventimeHeader from './components/EventimeHeader';
import EventimeHero from './components/EventimeHero';
import EventimeAbout from './components/EventimeAbout';
import EventimeServices from './components/EventimeServices';
import EventimeExpo from './components/EventimeExpo';
import EventimeUpcoming from './components/EventimeUpcoming';
import EventimeCareer from './components/EventimeCareer';
import EventimePICProfile from './components/EventimePICProfile';
import EventimeFooter from './components/EventimeFooter';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import EventimeInfoBar from './components/EventimeInfoBar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="eventime-app">
      <EventimeHeader />
      <main>
        <EventimeHero />
        <EventimeServices />
        <EventimeAbout />
        <EventimeExpo />
        <EventimeUpcoming />
        <EventimePICProfile />
        <EventimeCareer />
      </main>
      <EventimeFooter />
      <FloatingWhatsApp />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />}>
              <Route index element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;